import ReactGA from 'react-ga4'

// Fire a GA event so we can tell which button sends users to the dashboard.
export const trackDashboardClick = (source: string): void => {
  ReactGA.event({
    category: 'CTA',
    action: 'Open Dashboard',
    label: source,
  })
}
